import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';
import { environment } from '../../../environments/environment';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-checkout-complete-page',
  templateUrl: './checkout-complete-page.component.html',
  styleUrls: ['./checkout-complete-page.component.css']
})
export class CheckoutCompletePageComponent implements OnInit {
  
  pageName = "Checkout / Complete";

  modelId = '0'
  refNumber = ''
  pageReady = false
  retries = 0
  checkComplete = false
  txnRef

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private _ecomm: CommerceDataService
  ) { }

  ngOnInit() {

    $('#loader').show();

    $('#initialise-page').trigger('click');
    this.txnRef = sessionStorage.getItem('txn');

    
    // let transactionId = sessionStorage.getItem('transactionId')
    // let refNumber = sessionStorage.getItem('transactionRef')
    // if(transactionId && parseInt(transactionId) > 0) {
    //   this.modelId = transactionId
    //   this.refNumber = refNumber
    //   this.reviewOrderSummary()
    // }

    this.reviewOrderSummary()
  }

  reviewOrderSummary() {


      if(this.checkComplete == false) {



        if(this.txnRef) {

          let modelObject1 = new FormData();
          // modelObject1.append('id', this.modelId);
          // modelObject1.append('refNumber', this.refNumber);
          modelObject1.append('m_payment_id', this.txnRef);
          this.retries += 1
  
          this._data.dynamicFormPost(modelObject1, 'complete-order') 
            .pipe(first())
            .subscribe(
              data => {
  
                console.log(data)
                
  
                if(data['transaction'] != undefined) {
  
                  if(data['transaction']['status'] == "COMPLETE") {
                      this.pageReady = true;
                      this.checkComplete = true
  
                      this.refNumber = data['transaction']['refNumber'];
                      this._ecomm.cleanSessionOrderDetails();

                      
                      // setTimeout(()=>{    //<<<---    using ()=> syntax
                      //     this._ecomm.cleanSessionOrderDetails();
                      // }, 2000);
                  }
                  
  
                }
  
                this.pageReady = true;
              },
              error => {

                if(this.retries < 6) {
                  setTimeout(()=>{    //<<<---    using ()=> syntax
                          this.reviewOrderSummary();
                    }, 4000);
                }
                else
                  $('#loader').hide();
              },
              () => {
                // this.reviewOrderSummary()
                $('#loader').hide();
              }
          );
       
        }

      }
      
    

    else {
      $('#loader').hide();
      // this.router.navigate(['/home']);
    }
    
    
  }

}
